import { useState } from 'react';
import {
    FaStar,
    FaQuoteLeft,
    FaChevronLeft,
    FaChevronRight,
} from 'react-icons/fa';
import classes from './Testimonials.module.scss';

const testimonials = [
    {
        text: `Exceptional service and innovative solutions. The team exceeded our expectations and delivered ahead of schedule. Their technical depth and proactive communication made the entire process seamless.`,
        name: 'Vinutha Dhananjaya',
        role: 'Senior Solutions Architect',
        company: 'IKEA',
        rating: 5,
        initials: 'VD',
        accent: '#6366f1',
    },
    {
        text: `Working with this team was seamless. Strong communication, clean execution, and outstanding results. They turned our complex requirements into a polished product in record time.`,
        name: 'Rahul Mehta',
        role: 'Product Manager',
        company: 'FinTech Startup',
        rating: 5,
        initials: 'RM',
        accent: '#8b5cf6',
    },
    {
        text: `They understood our requirements deeply and translated them into a scalable, beautiful product. The attention to detail and commitment to quality was truly impressive.`,
        name: 'Ananya Verma',
        role: 'Founder',
        company: 'D2C Brand',
        rating: 5,
        initials: 'AV',
        accent: '#06b6d4',
    },
];

export default function Testimonials() {
    const [active, setActive] = useState(0);

    const prev = () =>
        setActive((p) => (p === 0 ? testimonials.length - 1 : p - 1));
    const next = () =>
        setActive((p) => (p === testimonials.length - 1 ? 0 : p + 1));

    return (
        <section className={classes.section}>
            <div className={classes.container}>
                {/* Header */}
                <div className={classes.header}>
                    <span className={classes.badge}>Testimonials</span>
                    <h2 className={classes.heading}>
                        What Our{' '}
                        <span className={classes.gradient}>Clients Say</span>
                    </h2>
                    <p className={classes.subtitle}>
                        Real feedback from businesses we've helped grow and scale
                    </p>
                </div>

                {/* Cards — all visible on desktop, single on mobile */}
                <div className={classes.grid}>
                    {testimonials.map((t, i) => (
                        <div
                            key={i}
                            className={`${classes.card} ${i === active ? classes.cardActive : ''}`}
                            style={{ '--card-accent': t.accent }}
                            onClick={() => setActive(i)}
                        >
                            {/* Quote icon */}
                            <FaQuoteLeft className={classes.quoteIcon} />

                            {/* Testimonial text */}
                            <p className={classes.text}>{t.text}</p>

                            {/* Stars */}
                            <div className={classes.stars}>
                                {Array.from({ length: t.rating }).map((_, si) => (
                                    <FaStar key={si} className={classes.star} />
                                ))}
                            </div>

                            {/* Divider */}
                            <div className={classes.divider} />

                            {/* Client info */}
                            <div className={classes.client}>
                                <div className={classes.avatar}>{t.initials}</div>
                                <div className={classes.clientMeta}>
                                    <h4 className={classes.clientName}>{t.name}</h4>
                                    <p className={classes.clientRole}>
                                        {t.role}, <span>{t.company}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Mobile navigation */}
                <div className={classes.mobileNav}>
                    <button
                        className={classes.arrow}
                        onClick={prev}
                        aria-label="Previous testimonial"
                    >
                        <FaChevronLeft />
                    </button>

                    <div className={classes.dots}>
                        {testimonials.map((_, i) => (
                            <button
                                key={i}
                                className={`${classes.dot} ${i === active ? classes.dotActive : ''}`}
                                onClick={() => setActive(i)}
                                aria-label={`Go to testimonial ${i + 1}`}
                            />
                        ))}
                    </div>

                    <button
                        className={classes.arrow}
                        onClick={next}
                        aria-label="Next testimonial"
                    >
                        <FaChevronRight />
                    </button>
                </div>
            </div>
        </section>
    );
}
